export default "__VITE_ASSET__DF_74KrO__"